export default {
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_LABEL: 'EYE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL: 'POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL_MOBILE: 'POWER/ SPHERE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL: 'DIA',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL: 'BC',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL: 'ADD POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL: 'BOXES',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL: 'AXIS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL: 'CYL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL: 'COLOR',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL: 'DOMINANCE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LONG_LABEL: 'OD (right)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LONG_LABEL: 'OS (left)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LONG_LABEL_DIF:
        'OD (right):',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LONG_LABEL_DIF:
        'OS (left):',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL: 'OD (right)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL: 'OS (left)',
    SAME_PRESCRIPTION_LABEL: 'Same prescription for both eyes',
    ADD_PRESCRIPTION_STEP_1_LEFT: 'OS (left)',
    CONTACT_LENSES_SUPPLY_TITLE: 'Choose your supply',
    CONTACT_LENSES_RIGHT_EYE: 'Right eye (OD)',
    CONTACT_LENSES_QTY: 'Qty',
    CONTACT_LENSES_LEFT_EYE: 'Left eye (OS)',
    CONTACT_LENSES_SHOW_SAVED_PRESCRIPTION: 'Show prescription',
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED:
        'Save your prescription to your account for a quick and easy checkout.',
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED_NO_PRESC_PT1:
        'You don’t have any prescription saved for this product yet.',
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED_NO_PRESC_PT2:
        'Add your prescription below and save it at checkout.',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1: 'Insert your prescription  below or',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2:
        'to use one of your prescriptions saved online or retrieved in store.',
    CONTACT_LENSES_PRESCRIPTION_INCLUDE_PRODUCT_IN_PURCHASE_CHECKBOX:
        'Include this product in my purchase',
    CONTACT_LENSES_REMOVE: 'Remove',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD: 'Uploaded on',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE: 'Last updated: ',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATED: 'Just updated',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY: 'Today',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY: 'Yesterday',
};
